import { useMemo } from 'react';
import { useAuth } from './useAuth';

/**
 * Empleado vinculado al usuario autenticado (GET /api/users/me → employee).
 * @returns {{ employeeId: number | null, employeeName: string, isLoading: boolean, isReady: boolean }}
 */
export function useCurrentEmployee() {
  const auth = useAuth();

  return useMemo(() => {
    const employee = auth?.apiUserData?.employee;
    const rawId = employee?.id;
    const parsedId = rawId != null && rawId !== '' ? Number(rawId) : null;
    const employeeId = parsedId != null && !Number.isNaN(parsedId) ? parsedId : null;

    const fromEmployee = [employee?.first_name, employee?.last_name]
      .filter(Boolean)
      .join(' ')
      .trim();
    const employeeName =
      fromEmployee ||
      auth?.apiUserData?.user?.name ||
      auth?.serverAuth?.user?.name ||
      auth?.user?.name ||
      '';

    return {
      employeeId,
      employeeName,
      isLoading: Boolean(auth?.isLoading),
      isReady: !auth?.isLoading && employeeId != null,
    };
  }, [auth]);
}
